import api from "./axios";

// Firm Profiles — the practice's own letterhead identities. Multi-record
// (the firm files under more than one legal entity). Used as the snapshot
// source on every generated tax invoice.
export const listFirmProfiles = () => api.get("/firm-profiles");
export const getFirmProfile = (id) => api.get(`/firm-profiles/${id}`);
export const createFirmProfile = (payload) => api.post("/firm-profiles", payload);
export const updateFirmProfile = (id, payload) =>
  api.put(`/firm-profiles/${id}`, payload);
export const deleteFirmProfile = (id) => api.delete(`/firm-profiles/${id}`);
